import Model from './src/Model.js'

const install = function (Vue, opts = {}) {
  Vue.prototype.$common = Common
}

const Common = {
  install: install,
  model: Model
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
};

export default Common



// WEBPACK FOOTER //
// ./src/common/index.js